import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'address-panel',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.css']
})
export class AddressComponent  {

  @Input() header = "";
  @Input() collapsed = false;
  @Output() collapsedChange: EventEmitter<boolean>;
  @Input() visible = false;
  @Input() items = "";
  @Input() yearDataDisplayed;


  constructor() {
    this.collapsedChange = new EventEmitter<boolean>();
  }

  onClick() {
    this.collapsedChange.emit(!this.collapsed);
  }
}



// WEBPACK FOOTER //
// ./src/app/profile/panels/address/address.component.ts